export class SearchLogsResponse {
    'pagination';
    'data';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        },
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<LogRecord>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchLogsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
